import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Replace with YOUR Firebase credentials
const firebaseConfig = {
  apiKey: "AIzaSyAAqw4xXq5fLP6sWSXmi23Q7adoRN7LswU",
  authDomain: "iseries-30134.firebaseapp.com",
  projectId: "iseries-30134",
  storageBucket: "iseries-30134.firebasestorage.app",
  messagingSenderId: "599281057758",
  appId: "1:599281057758:web:d08310363601e7eed0e74f",
  measurementId: "G-791DERFSQW"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export default app;